<template>
  <span class="text-danger text-sm">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: "validation-message"
}
</script>
